<template>
  <el-menu class="el-menu-vertical-president" active-text-color="#ffd04b">
    <el-submenu index="1">
      <template slot="title">
        <i class="el-icon-location"></i>
        <span>Ροές Εργασιών Από</span>
      </template>
      <el-menu-item v-for="role in this.roles" :key="role.id"
        @click="showApplicationsFrom(role.id)" :index="roleIndexId(role.id)">{{role.name}} <el-badge :value="role.badge"></el-badge>
      </el-menu-item>
    </el-submenu>
    <el-menu-item index='1000' @click="toggleSearch">
      <template slot="title">
        <span>Αναζήτηση Αιτήσεων</span>
      </template>
    </el-menu-item>
    <el-menu-item index='1001' @click="toggleUniSearch">
      <template slot="title">
        <span>Αναζήτηση Ιδρυμάτων</span>
      </template>
    </el-menu-item>
    <el-menu-item index='1002' @click="toggleConsultantsList">
      <template slot="title">
        <span>Λίστα αξιολογητών</span>
      </template>
    </el-menu-item>
  </el-menu>
</template>

<script>
import { mapState } from 'vuex'
import sharedMethods from '../common/sharedMethods.js'

export default {
  mixins: [sharedMethods],
  data () {
    return {
      roles: [
        { id: 1, name: 'Υπάλληλο Προελέγχου', badge: '' },
        { id: 2, name: 'Χειριστή', badge: '' },
        { id: 3, name: 'Εκτελεστική Επιτροπή', badge: '' },
        { id: 4, name: 'Αντιπρόεδρο', badge: '' },
        { id: 5, name: 'Καταχωρητή Απόφασης', badge: '' }
      ],
      laneFrom: '',
      index: 0
    }
  },
  computed: {
    ...mapState([
      'assignedApplications'
    ]),
    count () {
      return this.assignedApplications.length
    }
  },
  watch: {
    count (newCount, oldCount) {
      this.roles[this.index].badge = this.count
    }
  },
  methods: {
    showApplicationsFrom (id) {
      if (id === 1) {
        this.laneFrom = 'presidentW_Prechecker'
      } else if (id === 2) {
        this.laneFrom = 'viewerW_Proponent'
      } else if (id === 3) {
        this.laneFrom = 'viewerW_Board'
      } else if (id === 4) {
        this.laneFrom = 'viewerW_Vice'
      } else if (id === 5) {
        this.laneFrom = 'presidentW_PrintDecision'
      } else {
        return -1
      }
      this.index = id - 1
      this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.laneFrom).then(response => {
        this.roles[this.index].badge = response.length
      }).catch(err => {
        this.backendError(err)
        this.roles[this.index].badge = 'Error'
      })
    },
    roleIndexId (roleId) {
      return `${roleId}`
    },
    toggleSearch () {
      this.$store.dispatch('SHOW_HIDE_APPSEARCH')
    },
    toggleUniSearch () {
      this.$store.dispatch('SHOW_HIDE_UNISEARCH')
    },
    toggleConsultantsList () {
      this.$store.dispatch('SHOW_HIDE_CONSULTANTS_LIST')
    }
  }
}
</script>

<style lang='scss'>

li.el-menu-item.list-group-item {
  padding-left: 5px;
}
.el-menu-vertical-president {
  margin: 5px;
  word-wrap: break-word;
  border-radius: 0px 20px;
  border: 2px solid #7fa3bb;
  padding: 10px;
}
.el-submenu {
  border-radius: 20px;
  overflow-wrap: break-word;
  border: 2px solid #7fa3bb;
  padding: 5px;
  &__title:hover {
    background-color: "#b3c0d1";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/PresidentMenu.vue